import ACTIONS from '.';

// ─────────────────────────────────────
// RESPONSIVE — set whether we're on mobile width
// ─────────────────────────────────────
export const setResponsive = (isMobile) => ({
  type: ACTIONS.SET_RESPONSIVE,
  payload: isMobile,
});

// ─────────────────────────────────────
// MOBILE VIEW — which panel is showing on mobile
// ─────────────────────────────────────
export const setMobileView = (view) => ({
  type: ACTIONS.SET_MOBILE_VIEW,
  payload: view,
});
